import { render, staticRenderFns } from "./KycVerification.vue?vue&type=template&id=67d0c64c&scoped=true"
import script from "./KycVerification.vue?vue&type=script&lang=ts"
export * from "./KycVerification.vue?vue&type=script&lang=ts"
import style0 from "./KycVerification.vue?vue&type=style&index=0&id=67d0c64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0c64c",
  null
  
)

export default component.exports